// This file was automatically generated from print.visitNote.twoCol.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.visitNote.twoCol');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print.visitNote.vitals');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.model.note');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.print.visitNote.twoCol.sectionSubjective(opt_data, output);
  el8.template.print.visitNote.twoCol.sectionObjective(opt_data, output);
  if (opt_data.templateTypeMap.assessplan) {
    el8.template.print.visitNote.twoCol.sectionAssessplan(opt_data, output);
  } else {
    el8.template.print.visitNote.twoCol.sectionAssessment(opt_data, output);
    el8.template.print.visitNote.twoCol.sectionPlan(opt_data, output);
  }
  el8.template.print.visitNote.twoCol.sectionAttachments(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.field = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    if (opt_data.type == 'multilist' || opt_data.type == 'textmultilist') {
      el8.template.print.visitNote.twoCol.numberedList(opt_data, output);
    } else if (opt_data.type == 'listeditor' || opt_data.type == 'textlisteditor' || opt_data.type == 'textlist') {
      el8.template.print.visitNote.twoCol.listMultiple(opt_data, output);
    } else if (opt_data.type == 'textarea') {
      el8.template.print.visitNote.twoCol.listSingle(opt_data, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.genericList_ = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length == 1) {
    output.append('<li class="preserve item">');
    el8.template.ptdata.model.note.visitBullet({item: opt_data.items[0]}, output);
    output.append('</li>');
    el8.template.print.visitNote.twoCol.childrenList({item: opt_data.items[0]}, output);
  } else {
    var itemList18039 = opt_data.items;
    var itemListLen18039 = itemList18039.length;
    for (var itemIndex18039 = 0; itemIndex18039 < itemListLen18039; itemIndex18039++) {
      var itemData18039 = itemList18039[itemIndex18039];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.model.note.visitBullet({item: itemData18039}, output);
      output.append('</li>');
      el8.template.print.visitNote.twoCol.childrenList({item: itemData18039}, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.listSingle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append('<table class="subSection"><tr', (opt_data.bold) ? ' class="el8Bold"' : '', '>', (opt_data.label) ? '<td class="subSectionTitle">' + soy.$$escapeHtml(opt_data.label) + '</td>' : '', '<td class="subSectionText">');
    var itemList18061 = opt_data.items;
    var itemListLen18061 = itemList18061.length;
    for (var itemIndex18061 = 0; itemIndex18061 < itemListLen18061; itemIndex18061++) {
      var itemData18061 = itemList18061[itemIndex18061];
      output.append('<p class="preserve">');
      el8.template.ptdata.model.note.visitBullet({item: itemData18061}, output);
      output.append('</p>');
      el8.template.print.visitNote.twoCol.childrenList({item: itemData18061}, output);
    }
    output.append('</td></tr></table>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.numberedList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append((opt_data.label) ? '<h4' + ((opt_data.bold) ? ' class="el8Bold"' : '') + '>' + soy.$$escapeHtml(opt_data.label) + '</h4>' : '');
    var itemList18082 = opt_data.items;
    var itemListLen18082 = itemList18082.length;
    for (var itemIndex18082 = 0; itemIndex18082 < itemListLen18082; itemIndex18082++) {
      var itemData18082 = itemList18082[itemIndex18082];
      output.append('<p', (opt_data.bold) ? ' class="el8Bold"' : '', '><span>', soy.$$escapeHtml(itemIndex18082 + 1), '.</span><span class="leftIndent preserve">');
      el8.template.ptdata.model.note.visitBullet({item: itemData18082}, output);
      output.append('</span></p>');
      el8.template.print.visitNote.twoCol.childrenList({item: itemData18082, bold: opt_data.bold}, output);
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.listMultiple = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.items.length > 0) {
    output.append('<table class="subSection"><tr', (opt_data.bold) ? ' class="el8Bold"' : '', '>', (opt_data.label) ? '<td class="subSectionTitle">' + soy.$$escapeHtml(opt_data.label) + '</td>' : '', '<td class="subSectionText"><ul class="list">');
    el8.template.print.visitNote.twoCol.genericList_(opt_data, output);
    output.append('</ul></td></tr></table>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.childrenList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.item.children && opt_data.item.children.length > 0) {
    output.append('<ul class="multiList', (opt_data.bold) ? ' el8Bold' : '', '">');
    var childList18121 = opt_data.item.children;
    var childListLen18121 = childList18121.length;
    for (var childIndex18121 = 0; childIndex18121 < childListLen18121; childIndex18121++) {
      var childData18121 = childList18121[childIndex18121];
      output.append('<li class="itemBullet preserve">');
      el8.template.ptdata.model.note.visitBullet({item: childData18121}, output);
      output.append('</li>');
    }
    output.append('</ul>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.checklistList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var fieldList18129 = opt_data.fields;
  var fieldListLen18129 = fieldList18129.length;
  for (var fieldIndex18129 = 0; fieldIndex18129 < fieldListLen18129; fieldIndex18129++) {
    var fieldData18129 = fieldList18129[fieldIndex18129];
    output.append((fieldData18129.value) ? '<li class="item"><span class="upperCase">' + soy.$$escapeHtml(fieldData18129.name) + ':</span>' + ((fieldData18129.value) ? '<span class="leftIndent preserve">' + soy.$$escapeHtml(fieldData18129.value) + '</span>' : '') + '</li>' : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.sectionSubjective = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.problemBullets.length > 0 || opt_data.pastBullets.length > 0 || opt_data.surgicalBullets.length > 0 || opt_data.allergiesBullets.length > 0 || opt_data.habitsBullets.length > 0 || opt_data.familyBullets.length > 0 || opt_data.socialBullets.length > 0 || opt_data.medBullets.length > 0 || opt_data.rosBullets.length > 0 || opt_data.checklists.ros && opt_data.checklists.ros.length > 0) {
    output.append('<h4>Subjective</h4>');
    el8.template.print.visitNote.twoCol.field({items: opt_data.problemBullets, type: opt_data.templateTypeMap.problem}, output);
    el8.template.print.visitNote.twoCol.field({items: opt_data.allergiesBullets, label: 'Allergy:', bold: true, type: opt_data.templateTypeMap.allergies}, output);
    el8.template.print.visitNote.twoCol.field({items: opt_data.pastBullets, label: 'PMH:', type: opt_data.templateTypeMap.past}, output);
    el8.template.print.visitNote.twoCol.field({items: opt_data.surgicalBullets, label: 'PSH:', type: opt_data.templateTypeMap.surgical}, output);
    el8.template.print.visitNote.twoCol.field({label: 'FH:', items: opt_data.familyBullets, type: opt_data.templateTypeMap.family}, output);
    el8.template.print.visitNote.twoCol.field({label: 'SH:', items: opt_data.socialBullets, type: opt_data.templateTypeMap.social}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Habits:', items: opt_data.habitsBullets, type: opt_data.templateTypeMap.habits}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Meds:', items: opt_data.medBullets, type: opt_data.templateTypeMap.med}, output);
    if (opt_data.rosBullets.length > 0 || opt_data.checklists.ros && opt_data.checklists.ros.length > 0) {
      output.append('<table class="subSection"><tr><td class="subSectionTitle">ROS:</td><td class="subSectionText"><ul class="list">');
      el8.template.print.visitNote.twoCol.genericList_({items: opt_data.rosBullets}, output);
      if (opt_data.checklists.ros && opt_data.checklists.ros.length) {
        el8.template.print.visitNote.twoCol.checklistList({fields: opt_data.checklists.ros[0].fields}, output);
      }
      output.append('</ul></td></tr></table>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.sectionObjective = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.dataBullets.length > 0 || opt_data.peBullets.length > 0 || opt_data.checklists.pe && opt_data.checklists.pe.length > 0 || opt_data.hasVitals) {
    output.append('<h4>Objective</h4>');
    el8.template.print.visitNote.vitals.content(opt_data, output);
    if (opt_data.peBullets.length > 0 || opt_data.checklists.pe && opt_data.checklists.pe.length > 0) {
      output.append('<table class="subSection"><tr><td class="subSectionTitle">PE:</td><td class="subSectionText"><ul class="list">');
      el8.template.print.visitNote.twoCol.genericList_({items: opt_data.peBullets}, output);
      if (opt_data.checklists.pe && opt_data.checklists.pe.length) {
        el8.template.print.visitNote.twoCol.checklistList({fields: opt_data.checklists.pe[0].fields}, output);
      }
      output.append('</ul></td></tr></table>');
    }
    el8.template.print.visitNote.twoCol.field({items: opt_data.dataBullets, label: 'Data:', type: opt_data.templateTypeMap.data}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.sectionAssessment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.assessmentBullets.length > 0) {
    output.append('<h4>Assessment</h4>');
    el8.template.print.visitNote.twoCol.field({items: opt_data.assessmentBullets, type: opt_data.templateTypeMap.assessment}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.sectionPlan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.testBullets.length > 0 || opt_data.txBullets.length > 0 || opt_data.instrBullets.length > 0 || opt_data.procedureBullets.length > 0) {
    output.append('<h4>Plan</h4>');
    el8.template.print.visitNote.twoCol.field({label: 'Tests:', items: opt_data.testBullets, type: opt_data.templateTypeMap.test}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Tx:', items: opt_data.txBullets, type: opt_data.templateTypeMap.tx}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Proc:', items: opt_data.procedureBullets, type: opt_data.templateTypeMap.procedure}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Care Plan:', items: opt_data.instrBullets, type: opt_data.templateTypeMap.instr}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.sectionAssessplan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.assessplanBullets.length > 0 || opt_data.instrBullets.length > 0 || opt_data.ordersBullets.length > 0 || opt_data.procedureBullets.length > 0) {
    output.append('<h4>Assessment/Plan</h4>');
    el8.template.print.visitNote.twoCol.field({items: opt_data.assessplanBullets, type: opt_data.templateTypeMap.assessplan}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Proc:', items: opt_data.procedureBullets, type: opt_data.templateTypeMap.procedure}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Care:', items: opt_data.instrBullets, type: opt_data.templateTypeMap.instr}, output);
    el8.template.print.visitNote.twoCol.field({label: 'Orders:', items: opt_data.ordersBullets, type: opt_data.templateTypeMap.orders}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.twoCol.sectionAttachments = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.attachments.length) {
    output.append('<table class="subSection"><tr><td class="subSectionTitle">Original File:</td><td class="subSectionText"><ul class="list">');
    var itemList18257 = opt_data.attachments;
    var itemListLen18257 = itemList18257.length;
    for (var itemIndex18257 = 0; itemIndex18257 < itemListLen18257; itemIndex18257++) {
      var itemData18257 = itemList18257[itemIndex18257];
      output.append('<li class="preserve itemBullet">');
      el8.template.ptdata.model.attachment.summary(itemData18257, output);
      output.append('</li>');
    }
    output.append('</ul></td></tr></table>');
  }
  if (!opt_sb) return output.toString();
};
